.root {
  &[data-visible]::after {
    background-color: light-dark(var(--mantine-color-white), var(--mantine-color-primaryDark-8));
    background-image: url("../illustrations/loader.webp");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 220px;
  }
}
